import React, {Component} from 'react';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import {HeadlineH1, HeadlineH2} from './text/Headlines';
import ActionButtonRow from '../components/ActionButtonRow';
import ErrorMessage from '../components/ErrorMessage';
import styled from 'styled-components';
import convertErrors from '../helpers/errorHelper';
import DeviceList from './DeviceList';
import LogList from './LogList';
import {Trans, withNamespaces} from 'react-i18next';

const TableHeading = styled(HeadlineH2)`
  margin-top: 30px;
  margin-bottom: -40px;
`;

class Logs extends Component {
  constructor(props) {
    super(props);
    this.state = {device: undefined};
  }

  componentWillReceiveProps = (newProps) => {
    if (newProps.data.error) {
      const {graphQLErrors} = newProps.data.error || {};
      this.setState({errors: graphQLErrors});
    }
  };

  _goBackToList = () => this.props.history.replace('/users');

  _renderButtons = () => {
    const {t} = this.props;
    return (
      <ActionButtonRow>
        <FlatButton onClick={this._goBackToList} label={t('logs.overview')} />
        <FlatButton
          primary
          onClick={() => this.props.history.push('/user/' + this.props.match.params.id)}
          label={t('logs.editUser')}
        />
      </ActionButtonRow>
    );
  };

  _renderToggleDeviceBlockingDialog() {
    let {
      state: {device},
      props: {toggleDeviceBlocking},
    } = this;
    const {_id, active, name} = device || {};
    const {t} = this.props;
    let status = active ? t('logs.locked') : t('logs.unlocked');
    let usage = active ? t('logs.noLonger') : t('logs.again');

    console.log();
    return (
      <Dialog
        title={`${t('logs.device')} ${active ? t('logs.lock') : t('logs.unlock')}`}
        modal
        open={!!device}
        actions={[
          <FlatButton label={t('logs.cancel')} onClick={() => this.setState({device: undefined})} />,
          <FlatButton
            label={`${t('logs.confirmDevice')} ${active ? t('logs.lock') : t('logs.unlock')} ${t('logs.unlockDevice')}`}
            primary
            onClick={() => {
              toggleDeviceBlocking(_id).catch(this._showErrors);
              this.setState({device: undefined});
            }}
          />,
        ]}>
        <div>
          <Trans i18nKey={'logs.deviceText'}>
            Das Gerät {{name}} wird {{status}}.<br />
            Zukünftiges Anmelden mit dem Gerät ist {{usage}} möglich.
            <br />
            <br />
            Sind Sie sich wirklich sicher?
          </Trans>
        </div>
      </Dialog>
    );
  }

  _showErrors = (rawErrors) => {
    const {t} = this.props;
    let errors = convertErrors({...rawErrors, t: t});
    this.setState({errors});
    console.log('there was an error sending the sos mutation', errors);
  };

  render() {
    let {name, devices, logs} = this.props.data.user || {};
    const {t} = this.props;
    return (
      <div>
        <ErrorMessage errors={this.state.errors} clearErrors={() => this.setState({errors: []})} />
        <HeadlineH1>
          {t('logs.header')} - {name}
        </HeadlineH1>
        {devices && devices.length > 0 && (
          <div>
            <TableHeading>{t('logs.devices')}</TableHeading>
            <DeviceList devices={devices} toggleDeviceBlocking={(device) => this.setState({device})} />
          </div>
        )}
        {logs && logs.length > 0 && (
          <div>
            <TableHeading>{t('logs.header')}</TableHeading>
            <LogList logs={logs} toggleDeviceBlocking={(device) => this.setState({device})} />
          </div>
        )}
        {this._renderButtons()}
        {this._renderToggleDeviceBlockingDialog()}
      </div>
    );
  }
}
export default withNamespaces()(Logs);



// WEBPACK FOOTER //
// ./src/components/Logs.js